export default "__VITE_ASSET__UCQaLUgT__"